import axios from 'axios';

export const sendAnalytics = (type: string, target: string, builder?: string): void => {
  try {
    const payload = {
      type,
      date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      target,
      builder
    };

    console.log({payload})

    axios.post(
      'https://services.lashbrookdesigns.com/analytics.php',
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(() => {
      // toast.success('Analytics sent successfully.', { className: 'toast-success' });
    }).catch(() => {});
  } catch {
    // toast.error(errorMessage, { className: 'toast-error' });
  }
};
